import React, { createContext, useContext, useState, useEffect } from 'react';

const TeamContext = createContext();

export const useTeam = () => {
  const context = useContext(TeamContext);
  if (!context) {
    throw new Error('useTeam must be used within a TeamProvider');
  }
  return context;
};

export const TeamProvider = ({ children }) => {
  const [selectedTeamId, setSelectedTeamId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load selected team from localStorage on mount
    const loadSelectedTeam = () => {
      try {
        const teamId = localStorage.getItem('selected_team_id');
        if (teamId) {
          setSelectedTeamId(teamId);
        }
      } catch (error) {
        console.error('Error loading selected team:', error);
      } finally {
        setLoading(false);
      }
    };

    loadSelectedTeam();
  }, []);

  const selectTeam = (teamId) => {
    if (!teamId) {
      localStorage.removeItem('selected_team_id');
      localStorage.removeItem('current_user');
      setSelectedTeamId(null);
    } else {
      localStorage.setItem('selected_team_id', teamId);
      localStorage.removeItem('current_user'); // Clear user cache to force refresh
      setSelectedTeamId(teamId);
    }
  };

  const clearTeam = () => {
    localStorage.removeItem('selected_team_id');
    localStorage.removeItem('current_user');
    setSelectedTeamId(null);
  };

  const value = {
    selectedTeamId,
    setSelectedTeamId: selectTeam,
    clearTeam,
    hasTeam: !!selectedTeamId,
    loading
  };

  return (
    <TeamContext.Provider value={value}>
      {children}
    </TeamContext.Provider>
  );
};
